import EmojiObjectsOutlinedIcon from "@mui/icons-material/EmojiObjectsOutlined";
import { SxProps } from "@mui/material";
import { useAtomValue } from "jotai";
import { baseAtom } from "../../stores/jotai/base";
import HomeSegmentCard from "./HomeSegmentCard";
import HomeSegmentContent from "./HomeSegmentContent";
import HomeSegmentTitle from "./HomeSegmentTitle";
import InsightSegmentCardSkeleton from "./Skeleton/InsightSegmentCardSkeleton";
import InsightPage from "../../components/insights";

const CONTAINER_STYLES: SxProps = {
  "#audio": {
    display: "none"
  }
};

const InsightSegmentCard = () => {
  const base = useAtomValue(baseAtom);
  const isBaseLoading = Object.keys(base.user || {}).length === 0;

  return (
    <>
      {isBaseLoading ? (
        <InsightSegmentCardSkeleton />
      ) : (
        <HomeSegmentCard sx={CONTAINER_STYLES}>
          <HomeSegmentTitle>
            <EmojiObjectsOutlinedIcon /> Insights
          </HomeSegmentTitle>

          <HomeSegmentContent>
            <InsightPage />
            {/* <InsightTable
                hideToolbar={true}
                showDetail={(insight) => {
                  setSelectedInsightRow(insight);
                  navigate("/insights");
                }}
                setInsightTableDataLoading={setInsightTableDataLoading}
              /> */}
          </HomeSegmentContent>
        </HomeSegmentCard>
      )}
    </>
  );
};

export default InsightSegmentCard;
